import axios from 'axios';
import { PublicConfig } from '../../models/config';

export function getConfig(): Promise<PublicConfig> {
  return axios.get(`${window.apiBase}/public/config`).then(response => {
    return response.data;
  });
}
